import styles from './style.module.css';
import { useState, useRef, useEffect } from 'react';
import { errorSelector, useRecoilState} from 'recoil';
import { namespaceState } from '../../recoil/atoms';

import useApi from '../../services/useApi';
import getByteSize from '../../utils/getByteSize';
import Checkbox from '../Checkbox';
import Dropdown from '../Dropdown';
import { dataList } from '../../constants';
import FileDnD from '../FileDnD/FileDnD';

export default function ModelUploader({mode='modal',defaultDataset='EMNIST',onClose}){
    const [isDragOver,setIsDragOver]=useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadErr,setUploadErr] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadMsg,setUploadMsg]=useState("");
    const nameRef=useRef(null);
    const [fileName,setFileName]=useState(null);
    const [tempfileName,setTempFileName]=useState(null);
    const [namefocus,setNameFocus]=useState(false);
    const [nsState,setNsState] = useRecoilState(namespaceState);
    const [modelType,setModelType]=useState('classification');
    const [isDropReminder,setIsDropReminder]=useState(false);
    const [isQtz,setIsQtz]=useState(false);
    const [dataset,setDataset]=useState('EMNIST');
    const nocRef=useRef(null);
    const ctrRef=useRef(null);

    const handleUpload = async () => {
      if (!selectedFile) {
        setUploadErr(true);
        return;
      }
      setUploading(true);

      const nowDate=new Date();
      const fileData = {
          modelName: fileName,
          userId: JSON.parse(localStorage.getItem('account')).id,
          modelDescription: nowDate.getFullYear()+ " / " + ("0" + (nowDate.getMonth() + 1)).slice(-2) + " / "+ ("0" + nowDate.getDate()).slice(-2), //설명 대충 아무거나 적으심
          namespaceId:nsState.id,
          type:modelType,
          dropReminder:isDropReminder,
          quantization:isQtz,
          numOfClasses:modelType!=='classification'?0:nocRef.current.value,
          dataset:mode==='win'?dataset:defaultDataset,
          size: selectedFile.size/1024,
      }

      const formData = new FormData();
      formData.append('file', selectedFile);
      formData.append("model", new Blob([JSON.stringify(fileData)], {type: "application/json"}))
      const ctr=new AbortController();
      ctrRef.current=ctr;
      const config = {
          headers: {
              'content-type': 'multipart/mixed',
          },
          signal:ctr.signal,
          onUploadProgress:(e)=>{
            setUploadProgress(Math.round((e.loaded*100)/e.total));
          }
      };

      useApi.post('ngp/modelreg/mm/model/v1',formData,config).then((res)=>{
        setUploadMsg("Success");
      })
      .catch(async (err) => {
        if(err.code==='ERR_CANCELED'){
            console.log("Upload Cancel");
        }
        else if (err.response.data.code === "SE004" && err.response.status === 401) {
            setUploadMsg("Fail : " + err.response.data.message)
        } else if (err.response.data.code === "SE006" && err.response.status === 409) {
            setUploadMsg("Fail : " + err.response.data.message)
        } else {
            setUploadMsg("Fail : " + err.response.data)
        }
      });
    };

    const handleHeaderBtn=()=>{
        if(uploadMsg.includes('Success')){
            onClose();
        }
        if(ctrRef.current){
            ctrRef.current.abort();
        }
        setUploading(false);
        setUploadProgress(0);
        setUploadMsg("");
    }

    const handleNameChange=(e)=>{
        setTempFileName(e.target.value);
    }

    const handleNameKeyDown=(e)=>{
        if(e.key==='Enter' && e.target.value===''){
            setTempFileName(fileName);
            nameRef.current.blur();
        } else if(e.key==='Enter'){
            setFileName(tempfileName);
            nameRef.current.blur();
        } else if(e.key==='Escape'){
            setTempFileName(fileName);
            nameRef.current.blur();
        }
    }

    const handleNameBlur=(e)=>{
        if(e.type==='mouseup') setFileName(tempfileName);
        else if(e.target.value==="") setTempFileName(fileName);
        else if(e.target.value!=="") setFileName(tempfileName);
        nameRef.current.blur();
        setNameFocus(false);
    }

    const handleRemoveFile=(e)=>{
        e.preventDefault();
        e.stopPropagation();
        setSelectedFile(null);
        setUploading(false);
    }

    useEffect(()=>{
      setFileName(selectedFile?selectedFile.name.replace(/\.[^.]*$/,''):"");
      setTempFileName(selectedFile?selectedFile.name.replace(/\.[^.]*$/,''):"");
    },[selectedFile])

    useEffect(()=>{
        let timer;
        if(uploadErr){
            timer=setTimeout(() => {
                setUploadErr(false);
            }, 1200);
        }
        return()=>{
            clearTimeout(timer);
        }
    },[uploadErr])

    const uploadProgressStyle = {
      width: `${uploadProgress}%` 
    }

    return(
        <div className={`
        ${styles['wrap']} 
        ${uploading&&styles['wrap-uploading']}
        ${uploadMsg.includes('Fail')&&styles['err-ani']}
        `}>
            <header>
                <span>Model Upload{
                    uploadMsg===""?
                    "ing"
                    :" "+uploadMsg
                }</span>
                {uploading&&
                <div className={`${styles["upload-progress"]}`}>
                    {uploadMsg===""&&<>
                    <p>
                        <span>{uploadProgress}%</span>
                        <span>{" / "+fileName}</span>
                        <span>{" / "+getByteSize(selectedFile.size/1024)}</span>
                    </p>
                    <div className={`${styles["progress-bar"]}`}>
                        <div className={`${styles["progress-bar-now"]}`} style={uploadProgressStyle}/>
                    </div></>}
                    {uploadMsg==="Success"&&
                    <svg className={styles["upload-checkmark"]} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                      <circle className={styles["upload-checkmark-circle"]} cx="26" cy="26" r="25" fill="none"/>
                      <path className={styles["upload-checkmark-check"]} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                    </svg> 
                    }
                </div>}
                <button
                className={`
                ${styles['header-btn']} 
                ${mode==='win'&&!uploading&&styles['header-btn-disable']}
                ${uploading&&styles['header-btn-cancel']}
                ${uploadMsg.includes('Success')&&styles['header-btn-success']}
                ${uploadMsg.includes('Fail')&&styles['header-btn-fail']}
                `}
                onClick={uploading?handleHeaderBtn:onClose}
                />
            </header>
            <div className={`${styles['body']} ${uploading&&styles['body-uploading']}`}>
                <FileDnD
                defaultStyle={`${styles['dnd']} ${selectedFile&&styles['dnd-selected']}`}
                onFileDrop={(files)=>setSelectedFile(files[0])}
                onDragOver={(value)=>setIsDragOver(value)}
                clickDisabled={selectedFile}
                >
                    {!selectedFile?
                    <>{!isDragOver?
                        <p>
                            <span>Drag and drop</span>, or&nbsp;<span>browse</span>&nbsp;model file 
                        </p>
                        :
                        <div className={styles['dnd-over']}/>
                    }</>
                    :
                    <div className={styles["selected-wrap"]}>
                        <div className={styles["selected-header"]}>
                            <div>
                                {!namefocus?
                                <button 
                                className={`${styles["file-name-modify"]}`} 
                                onMouseUp={()=>{nameRef.current.focus()}}
                                />
                                :
                                <button 
                                className={`${styles["file-name-check"]}`} 
                                onMouseDown={e=>e.preventDefault()} 
                                onMouseUp={(e)=>{handleNameBlur(e)}}
                                />
                                }
                                <button className={styles["remove-file"]} onClick={handleRemoveFile}/>
                            </div>
                        </div>
                        <div className={styles["file-name-wrap"]}>
                            <input 
                            className={`${styles["file-name"]} ${namefocus&&styles['file-name-on']}`}
                            ref={nameRef}
                            placeholder={null}
                            value={tempfileName}
                            onChange={handleNameChange}
                            onKeyDown={handleNameKeyDown}
                            onFocus={()=>setNameFocus(true)}
                            onBlur={handleNameBlur}
                            />
                            <span className={styles["size"]}>{getByteSize(selectedFile.size/1024)}</span>
                        </div>
                    </div>
                    }
                </FileDnD>
                <div className={styles["form-wrap"]}><>
                    {mode==='win'&&
                    <div className={styles['file-item']}>
                      <span>Dataset</span>
                      <Dropdown 
                        list={dataList.map(item=>item.requiredName)}
                        selected={dataset} 
                        onChange={(e)=>{setDataset(e)}}
                        styleWidth={162}
                        isUpperCase={false}
                      />
                    </div>
                    }
                    <div className={`${styles['file-item']} ${styles["type"]}`}>
                      <span>Type</span>
                      <div className={styles["type-item"]}>
                        <div className={`${styles["type-item-btn"]} 
                        ${modelType=='classification'&&styles['type-item-btn-on']}`} 
                        onClick={()=>setModelType('classification')}>
                          Classification
                        </div>
                        <input 
                        ref={nocRef}
                        className={`${styles["type-item-input"]} 
                        ${modelType!='classification'&&styles['type-item-input-off']}`} 
                        placeholder='numOfClasses'
                        disabled={modelType=="classification"?false:true}>
                        </input>
                      </div>
                      <div className={`${styles["type-item-btn"]} ${modelType=='regression'&&styles['type-item-btn-on']}`} onClick={()=>setModelType('regression')}>
                        Regression
                      </div>
                      <div className={`${styles["type-item-btn"]} ${modelType=='generation'&&styles['type-item-btn-on']}`} onClick={()=>setModelType('generation')}>
                        Generation
                      </div>
                    </div>
                    <div className={styles['file-item']}>
                      <span>Hyperparameter</span>
                      <div className={styles['checkbox-dropreminder']}>
                        <Checkbox
                        textStyle={styles['checkbox-wrap']}
                        text="dropReminder"
                        onChange={()=>setIsDropReminder(!isDropReminder)}
                        />
                        <div className={styles['checkbox-dropreminder-info']}></div>
                      </div>
                    </div>
                    <div className={styles['file-item']}>
                      <span>Quantization</span>
                      <div className={styles['checkbox-qtz']}>
                        <Checkbox
                        textStyle={styles['checkbox-wrap']}
                        text="Float16"
                        onChange={()=>setIsQtz(!isQtz)}
                        />
                        <div className={styles['checkbox-qtz-info']}></div>
                      </div>
                    </div></>
                    <div className={styles["btn-wrap"]}>
                        <div className={`
                          ${styles["btn-upload"]} 
                          ${uploadErr&&styles['btn-upload-err']}`
                          } 
                          onClick={handleUpload}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}